import { render, staticRenderFns } from "./attach-view.vue?vue&type=template&id=2fa74468"
import script from "./attach-view.vue?vue&type=script&lang=js"
export * from "./attach-view.vue?vue&type=script&lang=js"
import style0 from "./attach-view.vue?vue&type=style&index=0&id=2fa74468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports